export default __webpack_public_path__ + "static/media/water-heater.301755b1.svg";